/**
 * Internationalization Configuration (i18n)
 *
 * This file configures the internationalization system for the application.
 * Features:
 * - Automatic language detection based on browser settings
 * - English and German language support
 * - Integration with react-i18next for component-level translations
 *
 * Usage in components:
 * ```jsx
 * import { useTranslation } from 'react-i18next';
 *
 * function MyComponent() {
 *   const { t } = useTranslation();
 *   return <div>{t('key.to.translate')}</div>;
 * }
 * ```
 *
 * @see https://www.i18next.com/overview/configuration-options
 * @see https://github.com/i18next/i18next-browser-languageDetector
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DE, EN } from "./translations"; // Import translation files

// Initialize i18n with plugins and configuration
i18n
  // Detect user language from browser settings
  .use(LanguageDetector)
  // Connect i18n with React components
  .use(initReactI18next)
  // Configure the i18n instance
  .init({
    // Default language if detection fails
    fallbackLng: "en",
    // Disable debug in production
    debug: false,
    // Configure available translations
    resources: {
      en: {
        translation: EN // English translations
      },
      de: {
        translation: DE // German translations
      }
    }
  });

export default i18n;
